import { createAsyncThunk } from "@src/store/createAsyncThunk";
import { actions } from "@src/store/slices/experienceBuilder/common/actions";
import { getVariationDraft } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraft";
import { getVariationDraftErrors } from "@src/store/slices/experienceBuilder/common/selectors/getVariationDraftErrors";
import { trackModSaved } from "@src/store/slices/experienceBuilder/common/thunks/mixPanel";
import { experienceBuilderSlice } from "@src/store/slices/experienceBuilder/slice";

export const applyDraft = createAsyncThunk<void, void>(
  "experienceBuilder/applyDraft",
  (_, { dispatch, getState }) => {
    const errors = getVariationDraftErrors(getState());
    if (errors) return;

    const mod = getVariationDraft(getState());
    if (!mod) return;

    dispatch(actions.clearDraft());
    dispatch(experienceBuilderSlice.actions.updateMods({ set: [mod] }));
    void dispatch(trackModSaved({ mod }));
  }
);
